import React, { createContext, useReducer } from 'react'
import { PageTypes } from '@hooks/Pages/usePages'
import ComponentMapping from '@common-types/ComponentMapping'

type PagesProviderTypes = {
  children: React.ReactNode
  config: Object
  locale: string
  componentMapping: ComponentMapping
}

const PagesInitialValue: any = {
  pages: undefined
}
const PagesActionTypes: any = {
  RECEIVE_PAGE: 'RECEIVE_PAGE'
}

export const PagesContext = createContext(PagesInitialValue)
export const PagesProvider = ({
  children,
  config,
  locale,
  componentMapping
}: PagesProviderTypes) => {
  const [state, dispatch] = useReducer((state: any, { type, payload }: any) => {
    let currentPage = state.currentPage
    if (
      (currentPage === undefined ||
        (currentPage !== undefined &&
          payload !== undefined &&
          currentPage.id !== payload.id)) &&
      payload.id !== 'global'
    ) {
      currentPage = payload
    }

    switch (type) {
      case PagesActionTypes.RECEIVE_PAGE: {
        return {
          ...state,
          pages: {
            ...state.pages,
            [payload.id]: payload
          },
          currentPage: currentPage
        }
      }
      default:
        throw new Error('Unknown action.')
    }
  }, PagesInitialValue)

  const actions = {
    receivePage: (page: PageTypes) =>
      dispatch({ type: PagesActionTypes.RECEIVE_PAGE, payload: page })
  }

  return (
    <PagesContext.Provider
      value={{ state, actions, config, locale, componentMapping }}
    >
      {children}
    </PagesContext.Provider>
  )
}
